import {
    promptTitle,
    promptDescription,
    promptYesLabel,
    promptNoLabel,
    ratingTitle1,
    ratingTitle2,
    ratingTitle3,
    ratingTitle4,
    ratingTitle5,
    easyOnRatingTitle1,
    easyOnRatingTitle2,
    easyOnRatingTitle3,
    easyOnRatingTitle4,
    easyOnRatingTitle5,
    moreInfoText,
    calendarSurveyPromptTitle,
    documentPreviewSurveyPromptTitle,
    documentPreviewSurveyRatingQuestion,
    translatorSurveyPromptTitle,
    translatorSurveyPromptSecondLineTwoQuestions,
    translatorPromptYesLabel,
    translatorPromptNoLabel,
    translatorSurveyRatingQuestion,
    translatorDialogSurveyCommentQuestion,
    translatorRatingTitle1,
    translatorRatingTitle5,
    inboxSurveyPromptTitle,
    inboxSurveyRatingQuestion,
    inboxEasyOnSurveyPromptTitle,
    inboxEasyOnSurveyRatingQuestion,
    linkPreviewSurveyPromptTitle,
    linkPreviewSurveyRatingQuestion,
} from './surveySettingsAndConstants.locstring.json';
import loc from 'owa-localize';
import { isGulpOrBranching } from 'owa-querystring';
import { isFeatureEnabled } from 'owa-feature-flags';

export type SurveyActivityType =
    | 'SearchExecuted'
    | 'AppointmentCreated'
    | 'MeetingCreated'
    | 'AppointmentUpdated'
    | 'MeetingUpdated'
    | 'MeetingCanceled'
    | 'EventViewed'
    | 'DocumentViewed'
    | 'LinkViewed'
    | 'TranslationCompleted'
    | 'InboxPlusExperimentSession'
    | 'InboxPlusEasyOnExperimentSession';

const enum StringsPlaceHolders {
    SEA_Prompt_Title = 'SEA_Prompt_Title',
    SEA_Prompt_Question = 'SEA_Prompt_Question',
    SEA_Prompt_YesLabel = 'SEA_Prompt_YesLabel',
    SEA_Prompt_NoLabel = 'SEA_Prompt_NoLabel',
    SEA_Rating_Question = 'SEA_Rating_Question',
    SEA_Rating_Values_1 = 'SEA_Rating_Values_1',
    SEA_Rating_Values_2 = 'SEA_Rating_Values_2',
    SEA_Rating_Values_3 = 'SEA_Rating_Values_3',
    SEA_Rating_Values_4 = 'SEA_Rating_Values_4',
    SEA_Rating_Values_5 = 'SEA_Rating_Values_5',
    SEA_Question_Question = 'SEA_Question_Question',
    CAL_Prompt_Title = 'CAL_Prompt_Title',
    CAL_Prompt_Question = 'CAL_Prompt_Question',
    CAL_Prompt_YesLabel = 'CAL_Prompt_YesLabel',
    CAL_Prompt_NoLabel = 'CAL_Prompt_NoLabel',
    CAL_Rating_Question = 'CAL_Rating_Question',
    CAL_Rating_Values_1 = 'CAL_Rating_Values_1',
    CAL_Rating_Values_2 = 'CAL_Rating_Values_2',
    CAL_Rating_Values_3 = 'CAL_Rating_Values_3',
    CAL_Rating_Values_4 = 'CAL_Rating_Values_4',
    CAL_Rating_Values_5 = 'CAL_Rating_Values_5',
    CAL_Question_Question = 'CAL_Question_Question',
    DOC_Prompt_Title = 'DOC_Prompt_Title',
    DOC_Prompt_Question = 'DOC_Prompt_Question',
    DOC_Prompt_YesLabel = 'DOC_Prompt_YesLabel',
    DOC_Prompt_NoLabel = 'DOC_Prompt_NoLabel',
    DOC_Rating_Question = 'DOC_Rating_Question',
    DOC_Rating_Values_1 = 'DOC_Rating_Values_1',
    DOC_Rating_Values_2 = 'DOC_Rating_Values_2',
    DOC_Rating_Values_3 = 'DOC_Rating_Values_3',
    DOC_Rating_Values_4 = 'DOC_Rating_Values_4',
    DOC_Rating_Values_5 = 'DOC_Rating_Values_5',
    DOC_Question_Question = 'DOC_Question_Question',
    TRA_Prompt_Title = 'TRA_Prompt_Title',
    TRA_Prompt_Question = 'TRA_Prompt_Question',
    TRA_Prompt_YesLabel = 'TRA_Prompt_YesLabel',
    TRA_Prompt_NoLabel = 'TRA_Prompt_NoLabel',
    TRA_Rating_Question = 'TRA_Rating_Question',
    TRA_Question_Question = 'TRA_Question_Question',
    TRA_Rating_Values_1 = 'TRA_Rating_Values_1',
    TRA_Rating_Values_2 = 'TRA_Rating_Values_2',
    TRA_Rating_Values_3 = 'TRA_Rating_Values_3',
    TRA_Rating_Values_4 = 'TRA_Rating_Values_4',
    TRA_Rating_Values_5 = 'TRA_Rating_Values_5',
    IBP_Prompt_Title = 'IBP_Prompt_Title',
    IBP_Prompt_Question = 'IBP_Prompt_Question',
    IBP_Prompt_YesLabel = 'IBP_Prompt_YesLabel',
    IBP_Prompt_NoLabel = 'IBP_Prompt_NoLabel',
    IBP_Rating_Question = 'IBP_Rating_Question',
    IBP_Rating_Values_1 = 'IBP_Rating_Values_1',
    IBP_Rating_Values_2 = 'IBP_Rating_Values_2',
    IBP_Rating_Values_3 = 'IBP_Rating_Values_3',
    IBP_Rating_Values_4 = 'IBP_Rating_Values_4',
    IBP_Rating_Values_5 = 'IBP_Rating_Values_5',
    IBP_Question_Question = 'IBP_Question_Question',
    IBPEA_Prompt_Title = 'IBPEA_Prompt_Title',
    IBPEA_Prompt_Question = 'IBPEA_Prompt_Question',
    IBPEA_Prompt_YesLabel = 'IBPEA_Prompt_YesLabel',
    IBPEA_Prompt_NoLabel = 'IBPEA_Prompt_NoLabel',
    IBPEA_Rating_Question = 'IBPEA_Rating_Question',
    IBPEA_Rating_Values_1 = 'IBPEA_Rating_Values_1',
    IBPEA_Rating_Values_2 = 'IBPEA_Rating_Values_2',
    IBPEA_Rating_Values_3 = 'IBPEA_Rating_Values_3',
    IBPEA_Rating_Values_4 = 'IBPEA_Rating_Values_4',
    IBPEA_Rating_Values_5 = 'IBPEA_Rating_Values_5',
    IBPEA_Question_Question = 'IBPEA_Question_Question',
    LINK_Prompt_Title = 'LINK_Prompt_Title',
    LINK_Prompt_Question = 'LINK_Prompt_Question',
    LINK_Prompt_YesLabel = 'LINK_Prompt_YesLabel',
    LINK_Prompt_NoLabel = 'LINK_Prompt_NoLabel',
    LINK_Rating_Question = 'LINK_Rating_Question',
    LINK_Rating_Values_1 = 'LINK_Rating_Values_1',
    LINK_Rating_Values_2 = 'LINK_Rating_Values_2',
    LINK_Rating_Values_3 = 'LINK_Rating_Values_3',
    LINK_Rating_Values_4 = 'LINK_Rating_Values_4',
    LINK_Rating_Values_5 = 'LINK_Rating_Values_5',
    LINK_Question_Question = 'LINK_Question_Question',
}

export const SurveyStringMap: { [stringPlaceHolder: string]: () => string } = {
    [StringsPlaceHolders.SEA_Prompt_Title]: () => loc(promptTitle),
    [StringsPlaceHolders.SEA_Prompt_Question]: () => loc(promptDescription),
    [StringsPlaceHolders.SEA_Prompt_YesLabel]: () => loc(promptYesLabel),
    [StringsPlaceHolders.SEA_Prompt_NoLabel]: () => loc(promptNoLabel),
    [StringsPlaceHolders.SEA_Rating_Question]: () => ' ', // We cannot omit this property (or pass empty string).
    [StringsPlaceHolders.SEA_Rating_Values_1]: () => loc(ratingTitle1),
    [StringsPlaceHolders.SEA_Rating_Values_2]: () => loc(ratingTitle2),
    [StringsPlaceHolders.SEA_Rating_Values_3]: () => loc(ratingTitle3),
    [StringsPlaceHolders.SEA_Rating_Values_4]: () => loc(ratingTitle4),
    [StringsPlaceHolders.SEA_Rating_Values_5]: () => loc(ratingTitle5),
    [StringsPlaceHolders.SEA_Question_Question]: () => loc(moreInfoText),
    [StringsPlaceHolders.CAL_Prompt_Title]: () => loc(calendarSurveyPromptTitle),
    [StringsPlaceHolders.CAL_Prompt_Question]: () => loc(promptDescription),
    [StringsPlaceHolders.CAL_Prompt_YesLabel]: () => loc(promptYesLabel),
    [StringsPlaceHolders.CAL_Prompt_NoLabel]: () => loc(promptNoLabel),
    [StringsPlaceHolders.CAL_Rating_Question]: () => ' ', // We cannot omit this property (or pass empty string).
    [StringsPlaceHolders.CAL_Rating_Values_1]: () => loc(ratingTitle1),
    [StringsPlaceHolders.CAL_Rating_Values_2]: () => loc(ratingTitle2),
    [StringsPlaceHolders.CAL_Rating_Values_3]: () => loc(ratingTitle3),
    [StringsPlaceHolders.CAL_Rating_Values_4]: () => loc(ratingTitle4),
    [StringsPlaceHolders.CAL_Rating_Values_5]: () => loc(ratingTitle5),
    [StringsPlaceHolders.CAL_Question_Question]: () => loc(moreInfoText),
    [StringsPlaceHolders.DOC_Prompt_Title]: () => loc(documentPreviewSurveyPromptTitle),
    [StringsPlaceHolders.DOC_Prompt_Question]: () => loc(promptDescription),
    [StringsPlaceHolders.DOC_Prompt_YesLabel]: () => loc(promptYesLabel),
    [StringsPlaceHolders.DOC_Prompt_NoLabel]: () => loc(promptNoLabel),
    [StringsPlaceHolders.DOC_Rating_Question]: () => loc(documentPreviewSurveyRatingQuestion),
    [StringsPlaceHolders.DOC_Rating_Values_1]: () => loc(ratingTitle1),
    [StringsPlaceHolders.DOC_Rating_Values_2]: () => loc(ratingTitle2),
    [StringsPlaceHolders.DOC_Rating_Values_3]: () => loc(ratingTitle3),
    [StringsPlaceHolders.DOC_Rating_Values_4]: () => loc(ratingTitle4),
    [StringsPlaceHolders.DOC_Rating_Values_5]: () => loc(ratingTitle5),
    [StringsPlaceHolders.DOC_Question_Question]: () => loc(moreInfoText),
    [StringsPlaceHolders.TRA_Prompt_Title]: () => loc(translatorSurveyPromptTitle),
    [StringsPlaceHolders.TRA_Prompt_Question]: () =>
        loc(translatorSurveyPromptSecondLineTwoQuestions),
    [StringsPlaceHolders.TRA_Prompt_YesLabel]: () => loc(translatorPromptYesLabel),
    [StringsPlaceHolders.TRA_Prompt_NoLabel]: () => loc(translatorPromptNoLabel),
    [StringsPlaceHolders.TRA_Rating_Question]: () => loc(translatorSurveyRatingQuestion),
    [StringsPlaceHolders.TRA_Question_Question]: () => loc(translatorDialogSurveyCommentQuestion),
    [StringsPlaceHolders.TRA_Rating_Values_1]: () => loc(translatorRatingTitle1),
    [StringsPlaceHolders.TRA_Rating_Values_2]: () => '2',
    [StringsPlaceHolders.TRA_Rating_Values_3]: () => '3',
    [StringsPlaceHolders.TRA_Rating_Values_4]: () => '4',
    [StringsPlaceHolders.TRA_Rating_Values_5]: () => loc(translatorRatingTitle5),
    [StringsPlaceHolders.IBP_Prompt_Title]: () => loc(inboxSurveyPromptTitle),
    [StringsPlaceHolders.IBP_Prompt_Question]: () => loc(promptDescription),
    [StringsPlaceHolders.IBP_Prompt_YesLabel]: () => loc(promptYesLabel),
    [StringsPlaceHolders.IBP_Prompt_NoLabel]: () => loc(promptNoLabel),
    [StringsPlaceHolders.IBP_Rating_Question]: () => loc(inboxSurveyRatingQuestion),
    [StringsPlaceHolders.IBP_Rating_Values_1]: () => loc(ratingTitle1),
    [StringsPlaceHolders.IBP_Rating_Values_2]: () => loc(ratingTitle2),
    [StringsPlaceHolders.IBP_Rating_Values_3]: () => loc(ratingTitle3),
    [StringsPlaceHolders.IBP_Rating_Values_4]: () => loc(ratingTitle4),
    [StringsPlaceHolders.IBP_Rating_Values_5]: () => loc(ratingTitle5),
    [StringsPlaceHolders.IBP_Question_Question]: () => loc(moreInfoText),
    [StringsPlaceHolders.IBPEA_Prompt_Title]: () => loc(inboxEasyOnSurveyPromptTitle),
    [StringsPlaceHolders.IBPEA_Prompt_Question]: () => loc(promptDescription),
    [StringsPlaceHolders.IBPEA_Prompt_YesLabel]: () => loc(promptYesLabel),
    [StringsPlaceHolders.IBPEA_Prompt_NoLabel]: () => loc(promptNoLabel),
    [StringsPlaceHolders.IBPEA_Rating_Question]: () => loc(inboxEasyOnSurveyRatingQuestion),
    [StringsPlaceHolders.IBPEA_Rating_Values_1]: () => loc(easyOnRatingTitle1),
    [StringsPlaceHolders.IBPEA_Rating_Values_2]: () => loc(easyOnRatingTitle2),
    [StringsPlaceHolders.IBPEA_Rating_Values_3]: () => loc(easyOnRatingTitle3),
    [StringsPlaceHolders.IBPEA_Rating_Values_4]: () => loc(easyOnRatingTitle4),
    [StringsPlaceHolders.IBPEA_Rating_Values_5]: () => loc(easyOnRatingTitle5),
    [StringsPlaceHolders.IBPEA_Question_Question]: () => loc(moreInfoText),
    [StringsPlaceHolders.LINK_Prompt_Title]: () => loc(linkPreviewSurveyPromptTitle),
    [StringsPlaceHolders.LINK_Prompt_Question]: () => loc(promptDescription),
    [StringsPlaceHolders.LINK_Prompt_YesLabel]: () => loc(promptYesLabel),
    [StringsPlaceHolders.LINK_Prompt_NoLabel]: () => loc(promptNoLabel),
    [StringsPlaceHolders.LINK_Rating_Question]: () => loc(linkPreviewSurveyRatingQuestion),
    [StringsPlaceHolders.LINK_Rating_Values_1]: () => loc(ratingTitle1),
    [StringsPlaceHolders.LINK_Rating_Values_2]: () => loc(ratingTitle2),
    [StringsPlaceHolders.LINK_Rating_Values_3]: () => loc(ratingTitle3),
    [StringsPlaceHolders.LINK_Rating_Values_4]: () => loc(ratingTitle4),
    [StringsPlaceHolders.LINK_Rating_Values_5]: () => loc(ratingTitle5),
    [StringsPlaceHolders.LINK_Question_Question]: () => loc(moreInfoText),
};

/**
 * For documentation and definition of the campaigns for floodgate, please see documentation at:
 * https://microsoft.sharepoint.com/teams/Office_CLE/officecustomervoice/SitePages/Office%20Feedback%20SDK%20-%20Web%20-%20Floodgate.aspx
 * https://microsoft.sharepoint.com/teams/Office_CLE/officecustomervoice/SitePages/Office%20Floodgate%20SDK.aspx
 */
export const surveryCampaignDefinitions = [
    {
        CampaignId: '2297b804-90bb-44c4-a0d4-73a8da24b81c',
        StartTimeUtc: '2018-06-01T00:00:00Z',
        EndTimeUtc: '2023-06-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('sea-floodgateSurveySDFSampling') ? 100 : 5,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'SearchExecuted',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.SEA_Prompt_Title,
                    Question: StringsPlaceHolders.SEA_Prompt_Question,
                    YesLabel: StringsPlaceHolders.SEA_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.SEA_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.SEA_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.SEA_Rating_Values_1,
                        StringsPlaceHolders.SEA_Rating_Values_2,
                        StringsPlaceHolders.SEA_Rating_Values_3,
                        StringsPlaceHolders.SEA_Rating_Values_4,
                        StringsPlaceHolders.SEA_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.SEA_Question_Question },
            },
        },
    },
    {
        CampaignId: '67e861da-9c21-4cc3-aaed-dc87c39a6e99',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyCreateApptBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'AppointmentCreated',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: '579612b7-b210-43d2-b7d6-7251f316beed',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyCreateMeetBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'MeetingCreated',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: '90c124f5-fd59-4711-9857-5892e4a76281',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyUpdateApptBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'AppointmentUpdated',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: '1d342f09-77ae-414c-8f11-790d087f9529',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyUpdateMeetBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'MeetingUpdated',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: 'dfdee7bb-9c94-43b0-85c6-edd17aa0f6ab',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyCancelMeetBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'MeetingCanceled',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: 'b173aebc-cb92-43bd-96d7-3300c35e68b7',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyViewEventBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'EventViewed',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: 'e38a3d7f-4f23-4551-8cbd-f02b0bf0d1c3',
        StartTimeUtc: '2019-01-01T00:00:00Z',
        EndTimeUtc: '2023-01-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('sea-floodgateSurveySDFSampling') ? 100 : 5, // Sample 100% of SDF (always left it as SDF flight) then 5% of upper rings.
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'DocumentViewed',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.DOC_Prompt_Title,
                    Question: StringsPlaceHolders.DOC_Prompt_Question,
                    YesLabel: StringsPlaceHolders.DOC_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.DOC_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.DOC_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.DOC_Rating_Values_1,
                        StringsPlaceHolders.DOC_Rating_Values_2,
                        StringsPlaceHolders.DOC_Rating_Values_3,
                        StringsPlaceHolders.DOC_Rating_Values_4,
                        StringsPlaceHolders.DOC_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.DOC_Question_Question },
            },
        },
    },
    {
        CampaignId: 'c376b98d-aa70-4d46-b9ff-a370cea8e438',
        StartTimeUtc: '2018-06-01T00:00:00Z',
        EndTimeUtc: '2020-06-01T00:00:00Z',
        GovernedChannelType: 0,
        AdditionalDataRequested: ['EmailAddress'],
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('sea-floodgateSurveySDFSampling')
                    ? 100
                    : 10, // Sample 100% of SDF (always left it as SDF flight) then 10% of upper rings.,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'TranslationCompleted',
                        Count: 1,
                        IsAggregate: false,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.TRA_Prompt_Title,
                    Question: StringsPlaceHolders.TRA_Prompt_Question,
                    YesLabel: StringsPlaceHolders.TRA_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.TRA_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.TRA_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.TRA_Rating_Values_1,
                        StringsPlaceHolders.TRA_Rating_Values_2,
                        StringsPlaceHolders.TRA_Rating_Values_3,
                        StringsPlaceHolders.TRA_Rating_Values_4,
                        StringsPlaceHolders.TRA_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.TRA_Question_Question },
            },
        },
    },
    {
        CampaignId: '774d7b3b-ad7a-44c3-90f7-552102395826',
        StartTimeUtc: '2019-07-17T00:00:00Z',
        EndTimeUtc: '2020-07-17T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() ||
                isFeatureEnabled('tri-inboxPlusDefaultTabs') ||
                isFeatureEnabled('tri-inboxPlusDefaultTabsControl')
                    ? 100
                    : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'InboxPlusExperimentSession',
                        Count: 5,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.IBP_Prompt_Title,
                    Question: StringsPlaceHolders.IBP_Prompt_Question,
                    YesLabel: StringsPlaceHolders.IBP_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.IBP_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.IBP_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.IBP_Rating_Values_1,
                        StringsPlaceHolders.IBP_Rating_Values_2,
                        StringsPlaceHolders.IBP_Rating_Values_3,
                        StringsPlaceHolders.IBP_Rating_Values_4,
                        StringsPlaceHolders.IBP_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.IBP_Question_Question },
            },
        },
    },
    {
        CampaignId: 'e10b430e-602d-4671-8403-410b625b06eb',
        StartTimeUtc: '2019-10-03T00:00:00Z',
        EndTimeUtc: '2020-10-03T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() ||
                isFeatureEnabled('tri-inboxPlusEasyOn') ||
                isFeatureEnabled('tri-inboxPlusEasyOnControl')
                    ? 100
                    : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'InboxPlusEasyOnExperimentSession',
                        Count: 5,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.IBPEA_Prompt_Title,
                    Question: StringsPlaceHolders.IBPEA_Prompt_Question,
                    YesLabel: StringsPlaceHolders.IBPEA_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.IBPEA_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.IBPEA_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.IBPEA_Rating_Values_1,
                        StringsPlaceHolders.IBPEA_Rating_Values_2,
                        StringsPlaceHolders.IBPEA_Rating_Values_3,
                        StringsPlaceHolders.IBPEA_Rating_Values_4,
                        StringsPlaceHolders.IBPEA_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.IBPEA_Question_Question },
            },
        },
    },
    {
        CampaignId: 'cfa827d8-3c47-42cd-a896-39cf2cc0c11e',
        StartTimeUtc: '2019-10-09T00:00:00Z',
        EndTimeUtc: '2023-10-09T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('sea-floodgateSurveySDFSampling') ? 100 : 5, // Sample 100% of SDF (always left it as SDF flight) then 5% of upper rings.
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'LinkViewed',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.LINK_Prompt_Title,
                    Question: StringsPlaceHolders.LINK_Prompt_Question,
                    YesLabel: StringsPlaceHolders.LINK_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.LINK_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.LINK_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.LINK_Rating_Values_1,
                        StringsPlaceHolders.LINK_Rating_Values_2,
                        StringsPlaceHolders.LINK_Rating_Values_3,
                        StringsPlaceHolders.LINK_Rating_Values_4,
                        StringsPlaceHolders.LINK_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.LINK_Question_Question },
            },
        },
    },
];
